import { timesheetsRef } from "../firebase";
import {
  calcJobsHours,
  calcJobsTotalCost,
  calcMaterialsVat,
  calcSubcontractorProfit,
  calcVat,
  fix2,
} from "./calculationFunctions";
// import { Parser } from "json2csv";
import { Parser } from "@json2csv/plainjs";

import { collection, doc, getDocs, query, where } from "firebase/firestore";

const defaultTotallingObj = {
  hours: 0,
  labour: 0,
  materials: 0,
  baseMaterials: 0,
  markup: 0,
  gross: 0,
  net: 0,
  vat: 0,
  vat2: 0,
  total: 0,
  total2: 0,
};

export function getYears() {
  //Returns the years which can be inputted into the accountant report.
  let today = new Date();
  let currentYear = today.getFullYear();
  let yearsAvailable = [];

  for (let i = currentYear; i > 2010; i--) {
    yearsAvailable.push(i);
  }
  return yearsAvailable;
}

export async function generateAccountantsReport(userData, startDate, endDate) {
  let q = query(
    timesheetsRef,
    where("createdBy", "in", userData.associatedAccounts),
    where("paid", "==", true),
    where("jobEnd", ">=", startDate),
    where("jobEnd", "<=", endDate),
    // .orderBy("refNumber", "desc")
  );
  let results = await getDocs(q);

  const resultData = [];

  results.forEach(async (ts) => {
    let tempTs = { ...ts.data(), jobDescriptions: [] };

    let tsJobsRef = collection(timesheetsRef, tempTs.uid, "jobDescriptions");
    let jobSnaps = await getDocs(tsJobsRef);

    jobSnaps.forEach((jobSnap) => {
      if (jobSnap.exists()) {
        tempTs.jobDescriptions.push(jobSnap.data());
      }
    });

    resultData.push({ ...tempTs });
  });

  return resultData;
}

// Processing Functions //////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////

// Need to find:
//  - sort into customer groups.

function sectionCustomers(timesheets) {
  // Section timesheets into an object that groups them by their customer (accessId).
  // Will group timesheets that don't have an access id into Private section.
  let customerGroups = {};

  timesheets.forEach((ts) => {
    let customerId = ts?.accessId ? ts.accessId : "Private";
    if (customerGroups[customerId]) {
      customerGroups[customerId] = [...customerGroups[customerId], ts];
    } else {
      customerGroups[customerId] = [{ ...ts }];
    }
  });

  return customerGroups;
}

function processCustomerGroups(customerSections) {
  let customerReports = {};
  let customerTotals = {};
  let totalsArray = [];

  for (let customerId in customerSections) {
    let timesheets = customerSections[customerId];

    // Create key on the customerReports object which has a key of the customer accessId
    // and a value of an array of the report lines which will be used in the report.
    customerReports[customerId] = timesheets.map((ts) => {
      let jobs = ts.jobDescriptions;
      //let labourCost = calcJobsSetPricesAndLabour(jobs);
      let [matsTotal, matsBase, matsMarkup, labour, net] = calcJobsTotalCost(jobs, ts?.vatMode);
      let hours = Number(calcJobsHours(jobs));

      //   Net, VAT and Total ////////////////////////////////////

      // Net = Labour + Materials
      // let net = Number(labour) + Number(matsTotal);

      let vatRate = 20; //20 / 100;

      let [vat, gross] = calcVat(Number(net), ts?.vatMode);

      // Gross = Net + VAT

      // let total = inc;

      ////////////////////////////////////////////////////////

      //   console.log("Timesheet:", ts.refNumber);
      //   console.log("Hours", hours);
      //   console.log("Materials Total cost", matsTotal);
      //   console.log("Materials Base", matsBase);
      //   console.log("Materials Diff", matsMarkup);
      //   console.log("Labour cost", labour);
      //   console.log("net", net);
      //   console.log("Gross", gross);
      //   console.log("vat rate", vatRate);
      //   console.log("vat", vat);
      //   console.log("Total (using net)", total);
      //   console.log("Total2 (using gross)", total2);

      // Net vat and Gross Vat: not sure what one to use here yet. Include before until picture
      // becomes clearer. Net vat and total is my preference at the moment though 25/4/21

      if (ts?.subcontracted) {
        return {
          customerId: customerId,
          refNumber: ts.refNumber,
          worksOrderNumber: ts.worksOrderNumber,
          hours: hours,
          labour: labour,
          materials: matsTotal,
          baseMaterials: matsBase,
          markup: matsMarkup,
          gross: gross,
          net: net,
          vr: vatRate,
          vat: vat,
          // vat2: grossVat,
          total: calcSubcontractorProfit(gross)[0],
          // Used to use to calculate total using net and netVat, but now just use gorss.
          // total: total,
          // total2: total2,
        };
      }

      return {
        customerId: customerId,
        refNumber: ts.refNumber,
        worksOrderNumber: ts.worksOrderNumber,
        hours: hours,
        labour: labour,
        materials: matsTotal,
        baseMaterials: matsBase,
        markup: matsMarkup,
        gross: gross,
        net: net,
        vr: vatRate,
        vat: vat,
        total: gross,
        // vat2: grossVat,
        // Used to use to calculate total using net and netVat, but now just use gorss.
        // total: total,
        // total2: total2,
      };
    });

    // console.log("Cusssy reports", Object.keys(customerReports));

    // Object.keys(customerReports).forEach((cusKey) => {
    //   customerReports[cusKey] = customerReports[cusKey].sort((a, b) => {
    //     return Number(a?.refNumber) - Number(b?.refNumber);
    //   });
    // });

    // console.log("Cusssy reports Ordered", customerReports["Private"]);

    // Using the report lines in customerReports, add up the total for each variable held.
    let totals = customerReports[customerId].reduce(totalUpReportLines, {
      ...defaultTotallingObj,
    });

    totals.labour = Number(totals.labour).toFixed(2);
    totals.materials = Number(totals.materials).toFixed(2);
    totals.gross = Number(totals.gross).toFixed(2);
    totals.net = Number(totals.net).toFixed(2);
    totals.markup = Number(totals.markup).toFixed(2);
    totals.baseMaterials = Number(totals.baseMaterials).toFixed(2);
    totals.total = Number(totals.total).toFixed(2);
    totals.vat = Number(totals.vat).toFixed(2);
    // Used to calculate total as being materials base + labour, but now just use gross.
    // totals.total = Number(totals.total).toFixed(2);

    // Create a single object which holds the report lines and the total for that every customer
    customerTotals[customerId] = {
      total: totals,
      lines: customerReports[customerId],
    };

    // Create an array of totals to make it easier to caclulate overall total later on.
    totalsArray.push(totals);
  }

  return { customerTotals, totalsArray };

  //   customerSections.map((section) => {
  //     // Hours
  //     // Labour
  //     // Materials:
  //     // Markup
  //     // Gross: Labour + Materials + Markup
  //     // Net: Labour + Markup
  //     // VR:
  //     // VAT: (VR / 100) * Net
  //     // Total: VAT + Net
  //     console.log("Section", section);
  //   });
}

function totalUpEntirePeriod({ totalsArray = [] }) {
  let total = totalsArray.reduce(totalUpReportLines, {
    ...defaultTotallingObj,
  });

  // console.log("total before:", total);
  total.labour = fix2(total.labour).toFixed(2);
  total.materials = fix2(total.materials).toFixed(2);
  total.markup = fix2(total.markup).toFixed(2);
  total.baseMaterials = fix2(total.baseMaterials).toFixed(2);
  total.gross = fix2(total.gross).toFixed(2);
  total.net = fix2(total.net).toFixed(2);
  total.total = fix2(total.total).toFixed(2);
  // Used to calculate total as being materials base + labour, but now just use gross.
  // total.total = Number(total.total).toFixed(2);
  // console.log("total", total);
  return total;
}

function totalUpReportLines(acc, report) {
  let {
    hours,
    labour,
    materials,
    baseMaterials,
    markup,
    gross,
    net,
    // vr,
    vat,
    vat2,
    total,
    total2,
  } = report;

  hours = Number(hours);
  labour = fix2(labour);
  materials = fix2(materials);
  baseMaterials = fix2(baseMaterials);
  markup = fix2(markup);
  gross = fix2(gross);
  net = fix2(net);
  vat = fix2(vat);

  vat2 = fix2(vat2);
  total = fix2(total);
  total2 = fix2(total2);

  return {
    hours: acc.hours + hours,
    labour: acc.labour + labour,
    materials: acc.materials + materials,
    baseMaterials: acc.baseMaterials + baseMaterials,
    markup: acc.markup + markup,
    gross: acc.gross + gross,
    net: acc.net + net,
    vr: 0,
    vat: acc.vat + vat,
    vat2: acc.vat2 + vat2,
    total: acc.total + total,
    total2: acc.labour + total2,
  };
}

export function processTimesheets(report = []) {
  // Split timesheets up into customer groups.
  let customerSections = sectionCustomers(report);

  // Return same group objects but instead of the full timesheet, replace with object
  // which contains all relevant info. Returns {customerTotals, totals}
  let customerGroups = processCustomerGroups(customerSections);
  let totalOverPeriod = totalUpEntirePeriod(customerGroups);

  return [customerGroups, totalOverPeriod];
}

export async function getTopLevelTimesheets(userData, startDate, endDate) {
  // Get timesheet docs needed to generate an accountants report. Doesn't include
  // the jobs collections attached to each timesheet.

  let q = query(
    timesheetsRef,
    where("createdBy", "in", userData.associatedAccounts),
    where("paid", "==", true),
    where("jobEnd", ">=", startDate),
    where("jobEnd", "<=", endDate),
    // .orderBy("refNumber", "desc")
  );
  let results = await getDocs(q);

  const resultData = [];

  results.forEach(async (ts) => {
    let tempTs = { ...ts.data() };

    resultData.push({ ...tempTs });
  });

  return resultData;
}

export async function addJobsToTimesheets(timesheetDocs) {
  // Retrieve jobs collections associated with the timesheets passed in, add them
  // to their timesheet and return them.

  const completeTimesheets = timesheetDocs.map(async (ts) => {
    let tempTs = { ...ts, jobDescriptions: [] };

    let tsJobsRef = collection(timesheetsRef, ts.uid, "jobDescriptions");
    let jobSnaps = await getDocs(tsJobsRef);

    jobSnaps.forEach((job) => {
      tempTs.jobDescriptions.push(job.data());
    });

    return tempTs;
  });

  // Need to make it a promise because the above map function isnt synchronous
  const returnedTimesheets = await Promise.all(completeTimesheets);

  return returnedTimesheets;
}

function formatTimesheets(customerGroups, totalOverPeriod) {
  let customerData = customerGroups?.customerTotals;
  let formattedCustomerData = [];

  // Push total into an array. Needed for csv processing
  let formattedTotal = [totalOverPeriod];

  // Get individual customer lines
  for (let customerId in customerData) {
    formattedCustomerData.push([...customerData[customerId].lines]);
  }

  return [formattedCustomerData.flat(1), formattedTotal];
}

export function createCSVData(customerGroups, totalOverPeriod, fieldsNeeded = []) {
  // Format the timesheets and total so that they can be added to csv data easily.
  let [flattenedTimesheets, total] = formatTimesheets(customerGroups, totalOverPeriod);

  // Actual CSV heading data in popData
  // let csvHeaders = accountantFields;

  let fields = fieldsNeeded
    .map((f) => {
      if (f.checked) {
        return {
          label: f.label,
          value: f.key,
        };
      } else {
        return null;
      }
    })
    .filter((x) => x);

  let csvHeaders = { fields: fields };

  // Parse object from json2csv package. TotalParser doesn't need a header.
  let timesheetsParser = new Parser(csvHeaders);
  let totalParser = new Parser({ ...csvHeaders, header: false });

  // Parse the timesheet and total data to make it ready for conversion
  let timesheetsCsv =
    flattenedTimesheets.length > 0 ? timesheetsParser.parse(flattenedTimesheets) : "no timesheets";

  let totalCsv = flattenedTimesheets.length > 0 ? totalParser.parse(total) : "no total";

  // Structure of the CSV file.
  let universalBOM = "\uFEFF"; //Lets excel know to use utf-8 encoding. Called a Byte Order Mark (BOM)
  let encodedCsvUri = encodeURI(universalBOM + timesheetsCsv + "\n\n\n" + totalCsv);

  let file = "data: text/csv;charset=utf-8," + encodedCsvUri;

  return file;
}
